import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Input } from 'reactstrap';

class BitFilter extends Component {
	constructor(props) {
        super(props);
        super(props);
        this.state = {
            value: props.value || false
        }
    }
	
	componentWillReceiveProps(nextProps) {
		const { filterStateMap, filterIndex } = nextProps;
        const savedFilterState = filterStateMap[`filter_${filterIndex}`];
		if(!savedFilterState) {
			this.setState({
				value: false
			})
		}
		
	}
	
	triggerFilterChange(value) {
        const { onFilterChange, filter, filterIndex } = this.props;
        this.setState({ value });
        const filterConfig = {
            filter,
            filterIndex
        }
		value != "" ? onFilterChange(filterConfig, [value]) : onFilterChange(filterConfig, []);
    }
	
	onChange(e) {
        const filterValue = e.target.checked;
        this.triggerFilterChange(filterValue);
    }
   
	render() {
        const { filter, elem_id } = this.props;
        return (
            <Col xs="12" className='w-100 p-0'>
                <Input 
					checked={this.state.value}
					onChange={this.onChange.bind(this)}
					type="checkbox"
					className='ml-1'
					style={{ height: '30px', width: '35px' }}
				/>
            </Col>
        );
    }
}

export default BitFilter;